export default __webpack_public_path__ + "bfebeb46863eba8876490e92d4e5a66b.png";